import { useTranslation } from "react-i18next"
import { Modal, Button, Text } from "@oysterhr/ui"
import { B2BPaymentMethod, CorePaymentMethod } from "@oysterhr/schema"

interface CreditorsIdModalProps {
  isOpen: boolean
  closeModal: () => void
  paymentMethod: CorePaymentMethod | B2BPaymentMethod
}

export const CreditorsIdModal = ({ isOpen, closeModal, paymentMethod }: CreditorsIdModalProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/CreditorsIdModal")

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>
        <Text>{t("description")}</Text>
        <Text className="font-semibold">{t(`creditorId.${paymentMethod.__typename}`)}</Text>
      </Modal.Content>
      <Modal.Footer>
        <Button variation="outline" onClick={closeModal}>
          {t("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
